import React, { Component } from "react";
import Styles from "./styles.module.css";
import Tv from "../../Assets/footer/tv.png";
// Social svg's import
import { ReactComponent as SocialYoutube } from "../../Assets/social/social-youtube.svg";
import { ReactComponent as SocialVimeo } from "../../Assets/social/social-vimeo.svg";
import { ReactComponent as SocialDevider } from "../../Assets/social/social-devider.svg";
import { ReactComponent as SocialFacebook } from "../../Assets/social/social-facebook.svg";
import { ReactComponent as SocialInstagram } from "../../Assets/social/social-instagram.svg";
import { Link } from "react-router-dom";

export default class Footer extends Component<{ image: string }> {
  constructor(props: any) {
    super(props);
  }
  render() {
    return (
      <div className={Styles.container}>
        <div className={Styles.social}>
          <a
            href="https://www.youtube.com/channel/UC4eePO9PJu1zp2Z3FCg8uMw"
            target="_blank"
          >
            <SocialYoutube />
          </a>
          <a href="https://vimeo.com/minimalmovie" target="_blank">
            <SocialVimeo />
          </a>
          <SocialDevider className={Styles.devider} />
          <a
            href="https://www.facebook.com/MinimalMovieProduction"
            target="_blank"
          >
            <SocialFacebook />
          </a>
          <a href="https://www.instagram.com/minimalmovie/" target="_blank">
            <SocialInstagram />
          </a>
        </div>
        <div className={Styles.text}>© 2023 Minimal Movie</div>
        {/* <div className={Styles.agencyLink}>
          <a href="https://chogo.agency/">Made by Chogo.Agency</a>
        </div> */}
        <div className={Styles.tv}>
          <img src={this.props.image} />
        </div>
      </div>
    );
  }
}
